import React from 'react'
import { type QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'

import 'dayjs/locale/ru'

import { type DomainUserRoleString, type UserModel } from '@/shared/api'
import { Devtools } from '@/shared/ui/devtools'
import { NotFound } from '@/shared/ui/not-found'

export interface MyRouterContext {
    queryClient: QueryClient
    auth: {
        profile?: UserModel
        hasAnyRole: (roles: DomainUserRoleString[]) => boolean
    }
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
    component: Root,
    notFoundComponent: NotFound,
})

function Root() {
    return (
        <>
            <Outlet />
            {!location.hostname.includes('taxoparkee.drivee.com') && <Devtools />}
        </>
    )
}
